import type { CSSProperties } from 'react';
import { useListRow } from '../List/ListRowContext';

interface MetricProps {
  value: string;
  label?: string;
  trend?: string;
  trendDirection?: 'up' | 'down' | 'flat';
  trendSentiment?: 'positive' | 'negative' | 'neutral';
  field?: string;
  className?: string;
  style?: CSSProperties;
}

const SENTIMENT_COLORS: Record<string, string> = {
  positive: 'text-green-600 dark:text-green-400',
  negative: 'text-red-600 dark:text-red-400',
  neutral: 'text-gray-500 dark:text-gray-400',
};

const DEFAULT_SENTIMENT: Record<string, string> = {
  up: 'positive',
  down: 'negative',
  flat: 'neutral',
};

export function resolveTrendSentiment(
  trendDirection: 'up' | 'down' | 'flat' | undefined,
  trendSentiment: 'positive' | 'negative' | 'neutral' | undefined
): string {
  return trendSentiment ?? DEFAULT_SENTIMENT[trendDirection ?? 'flat'] ?? 'neutral';
}

export function MetricView({
  value,
  label,
  trend,
  trendDirection,
  trendSentiment,
  field,
  className,
  style,
}: MetricProps) {
  const row = useListRow();
  const displayValue = field && row ? String(row[field] ?? value) : value;
  const sentiment = resolveTrendSentiment(trendDirection, trendSentiment);
  const trendColor = SENTIMENT_COLORS[sentiment];
  return (
    <div className={`flex flex-col gap-1${className ? ` ${className}` : ''}`} style={style}>
      {label && <span className="text-xs text-gray-500 dark:text-gray-400">{label}</span>}
      <span className="text-2xl font-bold">{displayValue}</span>
      {trend && <span className={`text-sm font-medium ${trendColor}`}>{trend}</span>}
    </div>
  );
}
